import React from 'react'
import { WindList } from "../helper/MenuList";
import MenuItem from '../components/MenuItem';
import '../styles/Winds.css'

function Wind() {
  return (
    <div className='wind'>
      <h1 className='windTitle'>Strong Winds</h1>
      <div className='windList'>
        {WindList.map((cardItem, key) => {
            return (
            <MenuItem 
                key={key}
                image={cardItem.image} 
                name={cardItem.name} 
                desc={cardItem.desc} />
            )
        })}
      </div>
    </div>
  )
}

export default Wind
